export function matrixToBlocks(matrix) {
  // there are some '|' to delimit blocks of values
  let submatrices = [];
  let header = matrix[0];
  let from = 0;
  let to = header.indexOf('|');
  let last = false;
  while (to > 0) {
    let submatrix = getSubMatrix(matrix, from, to);
    submatrices.push(submatrix);
    from = to + 1;
    let nextPipe = header.indexOf('|', to + 1);
    if (last) {
      to = nextPipe;
    } else if (nextPipe > 0) {
      to = nextPipe;
    } else {
      to = from + 6;
      last = true;
    }
  }

  let results = [];

  for (let submatrix of submatrices) {
    let block = [];
    let blocks = { header: block };
    results.push(blocks);
    let emptyLine = false;
    for (let fields of submatrix) {
      let nbNonEmptyFields = fields.filter((field) => field).length;
      if (nbNonEmptyFields === 1 && emptyLine && fields[0]) {
        // new block
        block = [];
        blocks[fields[0]] = block;
      }
      if (nbNonEmptyFields === 0) {
        emptyLine = true;
      } else {
        emptyLine = false;
        block.push(fields);
      }
    }
  }
  return results;
}

function getSubMatrix(matrix, from, to) {
  return matrix.map((line) =>
    line.slice(from, to).map((field) => {
      if (typeof field === 'string') return field.replace(/: *$/, '').trim();
      return field;
    }),
  );
}
